import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-628d6e3c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-part-b-general-trust-money" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "mt-3 mb-3" }, "General Trust Money", -1))
const _hoisted_3 = {
  key: 0,
  class: "questions-main"
}
const _hoisted_4 = { key: 4 }
const _hoisted_5 = { key: 5 }
const _hoisted_6 = { key: 6 }

export function render(_ctx, _cache) {
  const _component_RadioButtonBranchList = _resolveComponent("RadioButtonBranchList")
  const _component_RadioButtonHorizontal = _resolveComponent("RadioButtonHorizontal")
  const _component_RadioButtonVertical = _resolveComponent("RadioButtonVertical")
  const _component_FileUploader = _resolveComponent("FileUploader")
  const _component_BankAccount = _resolveComponent("BankAccount")
  const _component_Signatories = _resolveComponent("Signatories")
  const _component_RadioButtonWithFiles = _resolveComponent("RadioButtonWithFiles")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (!_ctx.loadingContent)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _hoisted_2,
          (_ctx.formPartBData?.generalTrustMoney?.atcsMainQuestions?.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formPartBData.generalTrustMoney.atcsMainQuestions, (q, i) => {
                  return (_openBlock(), _createElementBlock(_Fragment, null, [
                    (q.atcsQuestionTypeId==15)
                      ? (_openBlock(), _createBlock(_component_RadioButtonBranchList, {
                          key: 0,
                          class: "mt-3 mb-3",
                          question: _ctx.formPartBData.generalTrustMoney.atcsMainQuestions[i],
                          "onUpdate:question": $event => ((_ctx.formPartBData.generalTrustMoney.atcsMainQuestions[i]) = $event),
                          onValidForm: $event => (_ctx.validationForm(i, $event))
                        }, null, 8, ["question", "onUpdate:question", "onValidForm"]))
                      : _createCommentVNode("", true),
                    (q.atcsQuestionTypeId==10)
                      ? (_openBlock(), _createBlock(_component_RadioButtonHorizontal, {
                          key: 1,
                          class: "mt-3 mb-3",
                          question: _ctx.formPartBData.generalTrustMoney.atcsMainQuestions[i],
                          "onUpdate:question": $event => ((_ctx.formPartBData.generalTrustMoney.atcsMainQuestions[i]) = $event),
                          onValidForm: $event => (_ctx.validationForm(i, $event))
                        }, null, 8, ["question", "onUpdate:question", "onValidForm"]))
                      : _createCommentVNode("", true),
                    (q.atcsQuestionTypeId==11)
                      ? (_openBlock(), _createBlock(_component_RadioButtonVertical, {
                          key: 2,
                          class: "mt-3 mb-3",
                          question: _ctx.formPartBData.generalTrustMoney.atcsMainQuestions[i],
                          "onUpdate:question": $event => ((_ctx.formPartBData.generalTrustMoney.atcsMainQuestions[i]) = $event),
                          onValidForm: $event => (_ctx.validationForm(i, $event))
                        }, null, 8, ["question", "onUpdate:question", "onValidForm"]))
                      : _createCommentVNode("", true),
                    (q.atcsQuestionTypeId==8)
                      ? (_openBlock(), _createBlock(_component_FileUploader, {
                          key: 3,
                          class: "mt-3 mb-3",
                          question: _ctx.formPartBData.generalTrustMoney.atcsMainQuestions[i],
                          "onUpdate:question": $event => ((_ctx.formPartBData.generalTrustMoney.atcsMainQuestions[i]) = $event),
                          onValidForm: $event => (_ctx.validationForm(i, $event))
                        }, null, 8, ["question", "onUpdate:question", "onValidForm"]))
                      : _createCommentVNode("", true),
                    ((q.atcsQuestionTypeId==_ctx.QuestionType.PerBankAccount || q.atcsQuestionTypeId==_ctx.QuestionType.PerBankAccountV2) && this.formPartBData.generalTrustMoney?.atcsMainQuestions[i]?.formPracticeAccountQuestions)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                          _createVNode(_component_BankAccount, {
                            qWording: q.wording,
                            "onUpdate:qWording": $event => ((q.wording) = $event),
                            questionTypeId: q.atcsQuestionTypeId,
                            "onUpdate:questionTypeId": $event => ((q.atcsQuestionTypeId) = $event),
                            banks: this.formPartBData.generalTrustMoney.atcsMainQuestions[i].formPracticeAccountQuestions,
                            "onUpdate:banks": $event => ((this.formPartBData.generalTrustMoney.atcsMainQuestions[i].formPracticeAccountQuestions) = $event),
                            class: "mt-3 mb-3",
                            onValidForm: $event => (_ctx.validationForm(i, $event))
                          }, null, 8, ["qWording", "onUpdate:qWording", "questionTypeId", "onUpdate:questionTypeId", "banks", "onUpdate:banks", "onValidForm"])
                        ]))
                      : _createCommentVNode("", true),
                    (q.atcsQuestionTypeId==20 && this.formPartBData.generalTrustMoney?.atcsMainQuestions[i]?.formPracticeSignatoryQuestions)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                          _createVNode(_component_Signatories, {
                            qWording: q.wording,
                            "onUpdate:qWording": $event => ((q.wording) = $event),
                            signatories: this.formPartBData.generalTrustMoney.atcsMainQuestions[i].formPracticeSignatoryQuestions,
                            "onUpdate:signatories": $event => ((this.formPartBData.generalTrustMoney.atcsMainQuestions[i].formPracticeSignatoryQuestions) = $event),
                            isConfirmed: this.formPartBData.generalTrustMoney.isConfirmed,
                            "onUpdate:isConfirmed": _cache[0] || (_cache[0] = $event => ((this.formPartBData.generalTrustMoney.isConfirmed) = $event)),
                            class: "mt-3 mb-3",
                            onValidForm: $event => (_ctx.validationForm(i, $event))
                          }, null, 8, ["qWording", "onUpdate:qWording", "signatories", "onUpdate:signatories", "isConfirmed", "onValidForm"])
                        ]))
                      : _createCommentVNode("", true),
                    (q.atcsQuestionTypeId==_ctx.QuestionType.RadioButtonWithFiles)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                          (q.atcsQuestionTypeId==_ctx.QuestionType.RadioButtonWithFiles)
                            ? (_openBlock(), _createBlock(_component_RadioButtonWithFiles, {
                                key: 0,
                                class: "mt-3 mb-3",
                                question: _ctx.formPartBData.generalTrustMoney.atcsMainQuestions[i],
                                "onUpdate:question": $event => ((_ctx.formPartBData.generalTrustMoney.atcsMainQuestions[i]) = $event),
                                onValidForm: $event => (_ctx.validationForm(i, $event))
                              }, null, 8, ["question", "onUpdate:question", "onValidForm"]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 256))
              ]))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true)
  ]))
}